import { ComponentLocatorMap } from '../types/ComponentLocatorMap';

export const loanDocumentUploadedListComponent = {
  getDocumentItem: (index: number) =>
    `loan-document-uploaded-list.document-item-${index + 1}`,
  h3: 'loan-document-uploaded-list.h3',
  root: 'loan-document-uploaded-list.root',
} as const satisfies ComponentLocatorMap;
